/* Move the Clearpay badge before its live instalment message. */
(() => {
  const styleId = 'bn-clearpay-logo-left';

  const alignClearpayLogo = () => {
    document.querySelectorAll('square-placement').forEach((placement) => {
      const root = placement.shadowRoot;

      if (!root || root.getElementById(styleId)) return;

      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        .afterpay-paragraph {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 4px 8px !important;
          text-align: left !important;
        }

        .afterpay-logo-link {
          order: -1 !important;
          display: inline-flex !important;
          align-items: center !important;
          flex: 0 0 auto !important;
        }

        .afterpay-main-text {
          order: 0 !important;
        }
      `;

      root.appendChild(style);
    });
  };

  const clearpayIsAligned = () => {
    const placements = [...document.querySelectorAll('square-placement')];

    return placements.length > 0 && placements.every((placement) => {
      return placement.shadowRoot?.getElementById(styleId);
    });
  };

  let updateTimer;
  const observer = new MutationObserver(() => {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(alignClearpayLogo, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alignClearpayLogo, { once: true });
  } else {
    alignClearpayLogo();
  }

  customElements.whenDefined('square-placement').then(alignClearpayLogo);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  /* Clearpay can create its shadow content after its element has loaded. */
  let retryCount = 0;
  const retryTimer = window.setInterval(() => {
    retryCount += 1;
    alignClearpayLogo();

    if (clearpayIsAligned() || retryCount >= 40) {
      window.clearInterval(retryTimer);
    }
  }, 250);
})();
